<template>
    <div class="page">
        <div class="content"  :style="{backgroundImage: `url(${bgUrl})`}">
            <!--头部-->
            <div class="topHead">
                <topComponent title="分届别生源信息数据"></topComponent>
            </div>
						<el-select v-model="year" class="eselect"  placeholder="请选择" id="grade" @change='changeYear()' >
							<el-option
								v-for="item in all_years"
								:popper-append-to-body="false"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
            <div class="container-row">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" :lg="7" :xl="7">
                        <div class="left-col">
                            <div style="width: 100%;min-height:540px" class="boxbgimage firstContainer">
                                <img class="flashing2" src="../assets/image/flashing2.png">
                                 <el-row :gutter="0" class="col-3-box-h">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">毕业生院系分布</div>
                                        </div>
                                        <div class="echartBox">
                                            <div class="echart_padding" style="height: 240px;" ref="echarts_faculty"></div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">毕业生专业分布</div>
                                        </div>
                                        <div class="echartBox">
                                            <div class="echart_padding" style="height: 200px;" ref="echarts_major"></div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">毕业生学历分布</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 200px;" ref="echarts_education"></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div style="width: 100%;min-height:380px;margin-top: 26px" class="boxbgimage2 firstContainer sou-tag-box" >
                                <img class="sou-tag" src="../assets/image/line.png">
                                <el-row :gutter="0" class="col-3-box-h">
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">民族分布</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 335px;" ref="echarts_nation"></div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">性别分布</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 335px;" ref="echarts_gander"></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
                        <div class="center-col " >
                            <div class="top-col">
															<el-row :gutter="0" class="col-3-box-h">
																	<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
																			<div class="title">毕业生数量</div>
																			<div class="val">{{datasList.student_count}}</div>
																	</el-col>
															</el-row>
                            </div>
                            <div class="mapContainer">
                                <div class="echart_padding" style="height: 465px;" ref="chinaMap" v-show="mapType=='china'" ></div>
                                <div class="echart_padding" style="height: 465px;" ref="henanMap" v-show="mapType=='henan'" ></div>
																<div class="maplegendBox hide_in_mobile" v-if="datasList" >
																    <div class="itemTitleView">毕业生生源分布({{mapType=='china'?'全国':'河南'}}）</div>
																    <ul v-if="mapType=='china'">
																        <li class="flex_l" v-for="(province,index) of datasList.province_list.slice(0, 10)">
																            <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
																            <div class="maplegendTitle">{{province.name}}</div>
																            <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.count*110/datasList.province_list[0].count +'px'}">
																                <span>{{province.count}}</span>
																            </div>
																        </li>
																    </ul>
																    <ul v-if="mapType=='henan'">
																        <li class="flex_l" v-for="(province,index) of datasList.city_list.slice(0, 10)">
																            <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
																            <div class="maplegendTitle">{{province.name}}</div>
																            <div class="maplegendBarhover" :class="{'maplegendBar2':index<=2,'maplegendBarDown':index>2}" :style="{width: province.count*110/datasList.city_list[0].count +'px'}">
																                <span>{{province.count}}</span>
																            </div>
																        </li>
																    </ul>
																</div>
																<!-- 手动切换tab -->
																<!-- <el-radio-group v-model="mapType" size="mini" @change="mapTypeChange" class="mapTypeChange">
																    <el-radio-button label="china"></el-radio-button>
																    <el-radio-button label="henan"></el-radio-button>
																</el-radio-group> -->
                            </div>
                            <div class="center-bottom-col" style="overflow: hidden;">
															<img class="line_ex" src="../assets/image/line_ex.png">
															<div class="title">
																	<div class="tag"></div>
																	<div class="text">今日活跃学生动态</div>
															</div>
															<div>
																<div>
																	<div>
																		<div v-for='(item,index) in stuList_show' :class="index%2==0?'lightBlue list_style':'list_style'">
																			<span>
																				{{item.content}}
																			</span>
																		</div>
																	</div>
																</div>
															</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="7" :xl="7">
                        <div class="right-col">
                         <div style="width: 100%;height: 355px" class="boxbgimage5">
                             <img class="line_ex" src="../assets/image/line_ex.png">
                             <div class="right-item-col">
                                 <div class="title">
                                    <div class="tag"></div>
                                    <div class="text">今日活跃学生院系排名TOP10</div>
                                 </div>
                                 <div class="echart_padding" style="width:100%;height: 110px;" ref="echarts_faculty_active"></div>
                             </div>
                             <div class="right-item-col">
                                 <div class="title">
                                    <div class="tag"></div>
                                    <div class="text">今日活跃学生专业排名TOP10</div>
                                 </div>
                                 <div class="guimoEcharts active" style="width:100%;height: 130px;" ref="echarts_major_active"></div>
                             </div>
                         </div>
                        </div>
												<el-row :gutter="0" class="col-3-box-h boxbgimage5" style="margin-top:20px" >
												    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
															<div class="right-item-col">
																<img class="rings" src="../assets/image/stu_rings1.png" style="left: calc(50% - 90px);">
															    <div class="title">
															       <div class="tag"></div>
															       <div class="text">毕业生意向薪资分布</div>
															    </div>
															    <div class="guimoEcharts active" style="width:100%;height: 280px;" ref="echarts_salary">

																	</div>
															</div>
												    </el-col>
												    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
															<el-row >
																<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" >
																	<div class="right-item-col">
																			<div class="title">
																				 <div class="tag"></div>
																				 <div class="text">毕业生意向地域分布</div>
																			</div>
																			<div class="guimoEcharts active" style="width:100%;height: 203px;" ref="echarts_area"></div>
																	</div>
																 </el-col>
																<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" >
																	<div class="right-item-col">
																		<img class="rings2" src="../assets/image/stu_rings2.png" style="top: calc(50% - 44px)">
																			<div class="title">
																				 <div class="tag"></div>
																				 <div class="text">毕业生意向行业分布</div>
																			</div>
																			<div class="guimoEcharts active" style="width:100%;height: 203px;" ref="echarts_indestory"></div>
																	</div>
																 </el-col>
															</el-row>
												    </el-col>
												</el-row>
												<!-- <el-row :gutter="0" class="col-3-box-h boxbgimage6" style="margin-top:20px" >
													<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
														<div class="right-item-col">
															<div class="title">
																 <div class="tag"></div>
																 <div class="text">毕业生家庭住址分布</div>
															</div>
															<div class="home_box" v-if="datasList.home_address_list" >
																<span v-for="(item,index) in datasList.home_address_list.slice(0,10)">
																	<i class="home_tag" :style="'background:'+colorList[index] + (index%2!=0?';margin-left:10px':'') "></i>
																	<span class="home_name">{{item.name}}</span>
																</span>
															</div>
															<div class="guimoEcharts active" style="width:100%;height: 135px;" ref="echarts_home"></div>
														</div>
													</el-col>
												</el-row> -->
                    </el-col>

                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts'
	import {ref,getCurrentInstance,onMounted,reactive,onBeforeUnmount,onUnmounted} from 'vue'
		import http from '../public/http/index';
    import {
			initFaculty,
			initMajor,
			initEducation,
			initNation,
			initGender,
			initActiveFaculty,
			initActiveMajor,
			initSalary,
			initArea,
			initIndustory,
			initMap,
			initChinaMap,
			initHenanMap,
    } from '../public/studentsCharts'
    export default {
        setup() {
			var bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
			let backgroundJson =   localStorage.getItem('background');
			if(backgroundJson){
			    let background = JSON.parse(backgroundJson)
			    if(background.student){
					bgUrl = background.student;
				}
			}

			//左侧图表
						let year = ref(2021);
            let all_years = ref([]);
						let stuList = ref([]);
						let stuList_show = ref([]);
						let datasList = ref({home_address_list:[],province_list:[],city_list:[]})
						let colorList = ['#01CFFF','#0160C6','#0136C6','#011BC6','#0A01C6','#3653DE','#3B3BE3','#6666f3','#7f7ff0','#a2a2ed']
						let mapType = ref("china");
						//公共变量
            const echarts_faculty = ref(null);
            const echarts_major = ref(null);
            const echarts_education = ref(null);
            const echarts_nation = ref(null);
            const echarts_gander = ref(null);
						//地图图表
						const chinaMap = ref(null);
						const henanMap = ref(null);
						// 右侧图表
						const echarts_faculty_active = ref(null);
						const echarts_major_active = ref(null);
						const echarts_salary = ref(null);
						const echarts_area = ref(null);
						const echarts_indestory = ref(null);
						// const echarts_home = ref(null);
						const changeTime = 8000;
						let charts_faculty = null
						let charts_major = null
						let charts_education = null
						let charts_nation = null
						let charts_gander = null
						let charts_faculty_active = null
						let charts_major_active = null
						let charts_salary = null
						let charts_area = null
						let charts_indestory = null
						// let charts_home = null
						let charts_china = null
						let charts_henan = null;

						let timer_map = ref(false) //定时器
						let timer_faculty = ref(false);
						let timer_major = ref(false);
						let timer_active = ref(false);


            onMounted(() => {
							year.value = new Date().getFullYear()
							http.get_year_now().then(res=>{
								for(let i of res.data){
									all_years.value.push({
										value: i,
										label: i
									})
								}
							})
							
							console.log(all_years)
							http.get_screen_stu(year.value).then(res=>{
								console.log(res.data)
								datasList.value = res.data
								datasList.value.province_list.value = bubbleSort(res.data.province_list)
								datasList.value.city_list.value = bubbleSort(res.data.city_list)
								datasList.value.home_address_list.value= bubbleSort(res.data.home_address_list)
								console.log(datasList)
								charts_faculty = echarts.init(echarts_faculty.value);
								charts_major = echarts.init(echarts_major.value);
								charts_education = echarts.init(echarts_education.value);
								charts_nation = echarts.init(echarts_nation.value);
								charts_gander = echarts.init(echarts_gander.value);
								charts_faculty_active = echarts.init(echarts_faculty_active.value);
								charts_major_active = echarts.init(echarts_major_active.value);
								charts_salary = echarts.init(echarts_salary.value);
								charts_area = echarts.init(echarts_area.value);
								charts_indestory = echarts.init(echarts_indestory.value);
								// charts_home = echarts.init(echarts_home.value);
								charts_china = echarts.init(chinaMap.value);
								set_timer_faculty()
								set_timer_major()


								charts_education.setOption(initEducation(datasList.value));
								charts_nation.setOption(initNation(datasList.value));
								charts_gander.setOption(initGender(datasList.value));
								charts_faculty_active.setOption(initActiveFaculty(datasList.value));
								charts_major_active.setOption(initActiveMajor(datasList.value));
								charts_salary.setOption(initSalary(datasList.value));
								charts_area.setOption(initArea(datasList.value));
								charts_indestory.setOption(initIndustory(datasList.value));
								// charts_home.setOption(initMap(datasList.value));
								charts_china.setOption(initChinaMap(datasList.value));
								set_timer_map()
							})
							set_timer_active()

							window.onresize = function () {
							  if(charts_faculty){charts_faculty.resize();}
							  if(charts_major){charts_major.resize();}
							  if(charts_education){charts_education.resize();}
							  if(charts_nation){charts_nation.resize();}
							  if(charts_gander){charts_gander.resize();}
							  if(charts_faculty_active){charts_faculty_active.resize();}
							  if(charts_major_active){charts_major_active.resize();}
							  if(charts_salary){charts_salary.resize();}
							  if(charts_area){charts_area.resize();}
							  if(charts_indestory){charts_indestory.resize();}
							//   if(charts_home){
							// 		charts_home.setOption(initMap(datasList.value));
							// 		charts_home.resize();
							// 	}
								if(mapType.value == 'china'){
									charts_china.clear()
									charts_china.setOption(initChinaMap(datasList.value));
									charts_china.resize();
								}else{
									charts_henan.clear()
									charts_henan.setOption(initHenanMap(datasList.value));
									charts_henan.resize();
								}
							}
            })
						onUnmounted(()=>{
							if(timer_map){
								clearInterval(timer_map)
							}
						})

            const mapTypeChange = (e)=>{
							if(mapType.value == 'china'){
								if(!charts_china){
									charts_china = echarts.init(chinaMap.value);
									charts_china.setOption(initChinaMap(datasList.value));
								}
								set_timer_map()
							}else{
								if(!charts_henan){
									charts_henan = echarts.init(henanMap.value);
									charts_henan.setOption(initHenanMap(datasList.value));
								}
								set_timer_map()
							}
            }
						const changeYear = ()=>{
							http.get_screen_stu(year.value).then(res=>{
								datasList.value = res.data
								datasList.value.province_list.value = bubbleSort(res.data.province_list)
								datasList.value.city_list.value = bubbleSort(res.data.city_list)
								datasList.value.home_address_list.value= bubbleSort(res.data.home_address_list)

								charts_faculty.clear()
								set_timer_faculty()
								charts_major.clear()
								set_timer_major()
								charts_education.clear()
								charts_education.setOption(initEducation(datasList.value));
								charts_nation.clear()
								charts_nation.setOption(initNation(datasList.value));
								charts_gander.clear()
								charts_gander.setOption(initGender(datasList.value));
								charts_faculty_active.clear()
								charts_faculty_active.setOption(initActiveFaculty(datasList.value));
								charts_major_active.clear()
								charts_major_active.setOption(initActiveMajor(datasList.value));
								charts_salary.clear()
								charts_salary.setOption(initSalary(datasList.value));
								charts_area.clear()
								charts_area.setOption(initArea(datasList.value));
								charts_indestory.clear()
								charts_indestory.setOption(initIndustory(datasList.value));
								// charts_home.clear()
								// charts_home.setOption(initMap(datasList.value));
								if(mapType.value == 'china'){
									charts_china.clear()
									charts_china.setOption(initChinaMap(datasList.value));
								}else{
									charts_henan.clear()
									charts_henan.setOption(initHenanMap(datasList.value));
								}
								set_timer_map()
							})
							set_timer_active()
            }

						const set_timer_map = ()=>{
							if(timer_map){
								clearInterval(timer_map)
							}
							timer_map = setInterval(()=>{
								if(mapType.value == 'china'){
									mapType.value = 'henan'
									if(!charts_henan){
										setTimeout(()=>{
										    console.log('查看报错',henanMap.value,datasList.value)
											charts_henan = echarts.init(henanMap.value);
											charts_henan.setOption(initHenanMap(datasList.value));
										})
									}

								}else{
									mapType.value = 'china'
								}
							},changeTime)
						}

						const set_timer_active = ()=>{
							if(timer_active){
								clearInterval(timer_active)
							}
							http.get_stu_action(year.value).then(res=>{
								stuList_show.value=[]
								if(res.data.length >= 10){
									stuList.value = res.data.splice(0,10)
									localStorage.setItem('stu_active_list',JSON.stringify(stuList.value))
								}else{
									//数据不足时从本地填充
									if(localStorage.getItem('stu_active_list')){
										stuList.value = res.data.concat((JSON.parse(localStorage.getItem('stu_active_list'))).splice(0,10 - res.data.length))
										console.log(stuList.value)
									}
								}
								//手写动画效果
								if(timer){
									clearInterval(timer)
								}
								let count = 0
								let timer = setInterval(()=>{
									if(count == stuList.value.length){
										clearInterval(timer)
									}else{
										stuList_show.value.push(stuList.value[count])
										count+=1;
									}
								},70)
								timer_active = setInterval(()=>{
									http.get_stu_action(year.value).then(res=>{
										stuList_show.value=[]
										if(res.data.length >= 10){
											stuList.value = res.data.splice(0,10)
											localStorage.setItem('stu_active_list',JSON.stringify(stuList.value))
										}else{
											//数据不足时从本地填充
											if(localStorage.getItem('stu_active_list')){
												stuList.value = res.data.concat((JSON.parse(localStorage.getItem('stu_active_list'))).splice(0,10 - res.data.length))
												console.log(stuList.value)
											}
										}
										//手写动画效果
										if(timer){
											clearInterval(timer)
										}
										let count = 0
										let timer = setInterval(()=>{
											if(count == stuList.value.length){
												clearInterval(timer)
											}else{
												stuList_show.value.push(stuList.value[count])
												count+=1;
											}
										},70)
									})
								},changeTime)
							}).catch(()=>{
								console.log('loading error')
							})

						}

						const set_timer_faculty = ()=>{
							if(timer_faculty){
								clearInterval(timer_faculty)
							}
							let faculty_option = initFaculty(datasList.value)
							charts_faculty.setOption(faculty_option);

							// 切换内容
							timer_faculty = setInterval(()=>{
								if(datasList.value.faculty_list.length >= faculty_option.dataZoom.endValue+9){
									faculty_option.dataZoom.startValue = faculty_option.dataZoom.startValue+8
									faculty_option.dataZoom.endValue = faculty_option.dataZoom.endValue+8
									charts_faculty.setOption(faculty_option);
								}else if(datasList.value.faculty_list.length == (faculty_option.dataZoom.endValue+1)){
									faculty_option.dataZoom.startValue = 0
									faculty_option.dataZoom.endValue = 7
									charts_faculty.setOption(faculty_option);
								}else{
									faculty_option.dataZoom.startValue = faculty_option.dataZoom.startValue+8
									faculty_option.dataZoom.endValue = datasList.value.faculty_list.length-1
									charts_faculty.setOption(faculty_option);
								}
							},changeTime)
						}
						const set_timer_major = ()=>{
							if(timer_major){
								clearInterval(timer_major)
							}
							let major_option = initMajor(datasList.value)
							charts_major.setOption(major_option);
							timer_major = setInterval(()=>{
								if(datasList.value.major_list.length >= major_option.dataZoom.endValue + 7){
									major_option.dataZoom.startValue = major_option.dataZoom.startValue + 6
									major_option.dataZoom.endValue = major_option.dataZoom.endValue + 6
									charts_major.setOption(major_option);
								}else if(datasList.value.major_list.length == (major_option.dataZoom.endValue + 1)){
									major_option.dataZoom.startValue = 0
									major_option.dataZoom.endValue = 5
									charts_major.setOption(major_option);
								}else{
									major_option.dataZoom.startValue = major_option.dataZoom.startValue + 6
									major_option.dataZoom.endValue = datasList.value.major_list.length - 1
									charts_major.setOption(major_option);
								}
							},changeTime)
						}


						const bubbleSort = (arr)=>{
								let len = arr.length;
								for ( let j = 0; j < len - 1; j++) {
										for ( let i = 0; i < len - 1 - j; i++)
										{
												let a = arr[i];
												let b = arr[i + 1];
												if (a.value<b.value ) {
														let  temp = arr[i];
														arr[i] = arr[i + 1];
														arr[i + 1] = temp;
												}
										}
								}
								return arr;
						}

            return{
              all_years,
							year,
              echarts_faculty,
              echarts_major,
              echarts_education,
              echarts_nation,
              echarts_gander,
              echarts_faculty_active,
              echarts_major_active,
              echarts_salary,
              echarts_area,
              echarts_indestory,
            //   echarts_home,
              chinaMap,
              henanMap,
							charts_faculty,
							charts_major,
							charts_education,
							charts_nation,
							charts_gander,
							charts_faculty_active,
							charts_major_active,
							charts_salary,
							charts_area,
							charts_indestory,
							// charts_home,
							charts_china,
							charts_henan,
							mapTypeChange,
							mapType,
							changeYear,
							bubbleSort,
							changeTime,
							timer_map,
							set_timer_map,
							stuList,
							stuList_show,
							datasList,
							colorList,
							bgUrl,
							timer_faculty,
							timer_major,
							set_timer_faculty,
							set_timer_major,
							set_timer_active,
            }
        },

    }
</script>

<style scoped>
    .page {
        width: 100%;height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
    }
    .content {
        height: 100%;
        background: url("../assets/image/page_default_bg.png") no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        padding:0 20px;
        box-sizing: content-box;
        overflow-y:auto;
    }
    .top-row {
        width: 100%;
    }
    .container-row {
        width: 100%;
        /*margin-top: 25px;*/
        /* margin-bottom: 25px; */
    }
    .top-item {
        height: 200px;
        margin-bottom:25px;
    }

    .left-col {
        min-height: 700px;
    }
    .topHead {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }

    .topHead .b-title{
        width: 1040px;
        height: 109px;
        background: url("../assets/image/titlebg.png") no-repeat;
        background-size: 100% 109px;
        margin: 0 auto;
        text-align: center;
        font-size: 38px;
        font-weight: bold;
        color: #01EEDE;
        line-height: 90px;
    }
    .boxbgimage {
        background: url("../assets/image/block_bg1.png") no-repeat;
        background-size: 100% 100%;
    }
		.boxbgimage2 {
        background: url("../assets/image/block_bg2.png") no-repeat;
        background-size: 100% 100%;
    }
		.boxbgimage3 {
		    background: url("../assets/image/block_bg3.png") no-repeat;
		    background-size: 100% 100%;
		}

		.boxbgimage5 {
		    background: url("../assets/image/block_bg5.png") no-repeat;
		    background-size: 100% 100%;
		}
		.boxbgimage6 {
		    background: url("../assets/image/block_bg6.png") no-repeat;
		    background-size: 100% 100%;
		}

		/* 列表样式 */
		.lightBlue{
			background-color: rgba(59,108,148,.2);
		}
		.list_style{
			height: 33px;line-height: 33px;padding: 0 30px;text-align: left;color: whitesmoke;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
		}
		.list_style span{
			position: relative;
			left: 0;top: 0;
			-webkit-animation: activeInfo 8s linear infinite;
		}
		/* 家庭住址分布 */
		.home_box{
			display: inline-block;width: 240px;height: 110px;color: #84C7F7;font-size: 14px;position:absolute;top: 50px;left: 10px;
		}
		.home_tag{
			display: inline-block;width: 40px;height: 14px;border-radius: 1px;vertical-align: middle;margin-right: 10px;
		}
		.home_name{
			display: inline-block;width: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;text-align: left;
		}

    .echartBox{
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .echartBox .echart_padding{
        width: 100%;
    }
    .firstContainer{
        position: relative;
    }

    .firstContainer .flashing2{
        position: absolute;
        right: 0;
        top: 0;
    }

    .firstContainer .title{
        display: flex;
        align-items: center;
        margin: 20px 0 0 20px;
    }
    .firstContainer .title .tag{
        width: 3px;
        height: 20px;
        border-radius: 1px;
        background: #01EEDE;
    }

    .firstContainer .title .text{
        font-size: 16px;
        color: #01EEDE;
        margin-left: 10px;
        font-weight: bold;
    }
    /* 中间顶部三个模块 */
    .top-col{
        overflow: hidden;
        padding-top: 8px;
    }

    .top-col .title{
        font-size: 24px;
        font-weight: 600;
        color: #84C7F7;
        line-height: 33px;
    }
    .top-col .val{
        font-size: 44px;
        color: #FFFFFF;
        font-weight: bold;
        line-height: 60px;
        background: linear-gradient(226deg, #F8E98E 0%, #EFB758 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }


    .center-bottom-col{
        padding-top: 1px;
        height: 380px;
        position: relative;
        background: url("../assets/image/block_bg3.png") no-repeat;
        background-size: 100% 100%;
        /* padding-bottom: 20px; */
    }
    .center-bottom-col img{
        opacity: .6;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }
		.right-item-col{
			position:relative;
		}
    .center-bottom-col .title,.right-item-col .title{
        display: flex;
        align-items: center;
        margin: 20px 0 10px 20px;
    }
    .center-bottom-col .title .tag,.right-item-col .title .tag{
        width: 3px;
        height: 20px;
        border-radius: 1px;
        background: #01EEDE;
    }
    .center-bottom-col .title .text,.right-item-col .title .text{
        font-size: 16px;
        color: #01EEDE;
        margin-left: 10px;
        font-weight: bold;
    }
    .right-col{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .right-item-col .title{
        margin: 0 0 0 20px;
        padding-top: 20px;
    }

    .right-col .guimoEcharts{
        margin: 20px auto;
    }
    .right-col .guimoEcharts.active{
        margin-bottom: 0;
    }

    .sou-tag-box{
        position: relative;
        overflow: hidden;
    }

		.mapTypeChange {
		    position: absolute;
		    right: 15px;
		    top: 15px;
		}
		.flex_l{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-start;}
		.mapContainer{
		  position:relative;
		}
		/* 表格去除背景 */
		.el-table th, .el-table tr{
			background:inherit
		}
		/* 地图图例 */
		/* title 44px */
		.itemTitleView{
		    height: 20px;
		    line-height: 20px;
		    font-size: 18px;
		    color: rgba(1, 238, 222, 1);
		    border-left: 3px rgba(1, 238, 222, 1) solid;
		    font-weight: bold;
		    margin-top: 20px;
		    text-align: left;
		    padding-left: 5px;
		}
		.maplegendBox{
		    width: 200px;height: auto;max-height:260px;position: absolute;bottom: 5px;right:0;overflow-y:auto;
		}
		.maplegendBox::-webkit-scrollbar {
			display: none;
		}
		.maplegendBox ul{
		    list-style: none;
		    padding-left: 0;
		    margin-left: 0;
		}
		.maplegendBox ul li{
		    height: 15px;
		    margin: 5px;
		}
		.maplegendNumber {
		    width: 14px;
		    height: 14px;
		    font-size: 10px;
		    background-color: #02D1FB;
		    text-align: center;
		    margin-right: 3px;
		    border-radius: 3px;
		    color: white;
		    line-height: 14px;
		}
		.maplegendNumberDown {
		    width: 14px;
		    height: 14px;
		    font-size: 10px;
		    background-color: #3653DE;
		    text-align: center;
		    margin-right: 3px;
		    border-radius: 3px;
		    color: white;
		    line-height: 14px;
		}
		.maplegendTitle {
				display: inline-block;
		    color: #84C7F7;
		    font-size: 12px;
		    width: 50px;
				overflow: hidden;
				text-align: left;
				text-overflow: ellipsis;
				white-space: nowrap;
		    text-align: left;
		    line-height: 14px;
		}
		.maplegendBar{
		    width: 100px;
		    height: 12px;
		    border-bottom-right-radius: 7px;
		    border-top-right-radius: 7px;
		    background: -webkit-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
		    background: -o-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
		    background: -ms-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
		    background: linear-gradient(to right, #00CCFF 0%,#A6EDFF 100%);
		    cursor: pointer;
		}
		.maplegendBar2{
		    width: 100px;
		    height: 12px;
		    border-bottom-right-radius: 7px;
		    border-top-right-radius: 7px;
            background: -webkit-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
            background: -o-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
            background: -ms-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
            background: linear-gradient(to right, #00CCFF 0%,#A6EDFF 100%);
		    cursor: pointer;
		}
		.maplegendBarDown{
		    width: 100px;
		    height: 12px;
		    border-bottom-right-radius: 7px;
		    border-top-right-radius: 7px;
		    background: -webkit-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
		    background: -o-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
		    background: -ms-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
		    background: linear-gradient(to right, #3B3BE3 0%,#24A0CD 100%);
		}
		.maplegendBarhover {
		    line-height: 12px;
		    color: white;
		    text-align: left;
		}
		.maplegendBarhover span{
		    opacity: 0;
		    margin-left: 5px;
		    font-size: 12px;
		}
		.maplegendBarhover:hover{
		    border: 1px white solid;
		    cursor: pointer;
		}
		.maplegendBarhover:hover span{
		    opacity: 1;
		}

    /*动效*/
		.rings{
			width: 180px;
			height: 180px;
			position: absolute;
			top: 67px;
			left: 43px;
			-webkit-animation: rotating 5s linear infinite;
		}
		.rings2{
			width: 130px;
			height: 130px;
			position: absolute;
			top: 50px;
			left: 30px;
			-webkit-animation: rotating 5s linear infinite;
		}
    .flashing2{
        -webkit-animation:flashing2 5s linear infinite;
    }
    .sou-tag-box .sou-tag{
        width: 171px;
        height: 4px;
        position: absolute;
        left: -171px;
        top: 0;
        -webkit-animation:toRight 5s linear infinite;
    }
    .center-bottom-col .line_ex,.right-col .line_ex{
        width: 210px;
        height: 63px;
        position: absolute;
        left: 0;
        top: -29px;
        opacity: .2;
        -webkit-animation: toRight2 8s linear infinite;
    }
		/* select */
		.eselect >>> .el-input__inner{
			background-color: rgba(7,48,89,.4);
			box-shadow: 0px 0px 10px 0px #3272ec;
			color: #fff;
		}

    @-webkit-keyframes flashing2{
        0%{opacity:1;}
        50%{opacity:0}
        100%{opacity:1}
    }
    @-webkit-keyframes toRight{
        0%{left:-171px;
            opacity: .3;
        }
        20%{left:-171px;
            opacity: 1;
        }
        75%{
            opacity: 1;
        }
        100%{left:80%;
            opacity: 0;
        }
    }
    @-webkit-keyframes toRight2{

    0%{left:-10px;
        opacity: .2;}
    35%{
        opacity: .5;}
    75%{
        opacity: .5;
    }
    85%{
        opacity: .2;
    }
    100%{left:520px;
        opacity: 0;}
}  
 @-webkit-keyframes activeInfo{
    0%{left:-100px;}
		5%{left:10px;}
    10%{left:0px;}
    100%{left:0px;}
}

    @media screen and (max-width: 600px) {
        /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
        .content {
            padding: 5px;
        }
        .top-item {
            margin-bottom:5px;
        }
        .left-col {
            margin-bottom: 5px;
        }
        .container-row{
            margin-top: 0;
        }
        .content {
            height: 100%;
            background: url("../assets/image/page_mobile_default_bg.png") no-repeat;
            background-size: 100% 100%;
        }
				.el-select{
					position:fixed;left:20px;top:75px;width:140px;height:35px;z-index: 1;
				}
    }
		@media screen and (min-width: 600px) {
        /*当屏幕尺寸大于600px时，应用下面的CSS样式*/
        .el-select{
        	position:fixed;left:300px;top:30px;width:140px;height:35px;z-index: 1;
        }
    }
		@media screen and (max-width: 1200px) {
		    /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
		    .hide_in_mobile {
		      display:none;
		    }
				.center-bottom-col{
					margin:20px 0;
				}
		}
		@media screen and (min-width: 1200px) {
		    /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
		    .hide_in_mobile {
		      display:block;
		    }
				.center-bottom-col{
					margin:0;
				}
		}
		@media screen and (max-width: 1920px) {
		    /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
		    .rings {
		      display:none;
		    }
				.rings2{
					display:none;
				}
		}
		@media screen and (min-width: 1920px) {
		    /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
		    .rings {
		      display:block;
		    }
				.rings2{
					display:block;
				}
		}
</style>

